module.exports = __webpack_public_path__ + "media/presentacion_vertical.9aa31d68.mp4";